import { render } from "./CarpoolItem.component.vue?vue&type=template&id=58a537cc"
import script from "./CarpoolItem.component.vue?vue&type=script&lang=js"
export * from "./CarpoolItem.component.vue?vue&type=script&lang=js"

import "./CarpoolItem.component.vue?vue&type=style&index=0&id=58a537cc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__